import React from "react";
import Navbar from "../Components/Navbar";
import "../index.css";
import CertificateLeaderboard from "../Components/CertificateLeaderboard";
import EventLeaderboard from "../Components/EventLeaderboard";
import Hero from "../Components/Hero";
import Footer from "../Components/Footer";
const Home = () => {
  return (
    <div className="bg-slate-700 cursor">
      <Navbar />
      <Hero />
      <div className="bg-gradient-to-br from-black to-gray-900  ">
        <h1 className="text-white font-bold text-3xl flex justify-center py-3 bg-transparent">
          LeaderBoard
        </h1>
        <div className="md:flex py-20 justify-around">
          <CertificateLeaderboard />
          <EventLeaderboard />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
